import { Link } from "react-router-dom";
import logoImage from "../assets/images/logo-with-name.png";
import navigation from "../data/mainMenus.js";

export default function Footer() {
  return (
    <footer className="bg-gray-900 text-gray-200 pt-10 pb-6">
      <div className="mx-auto max-w-7xl px-4 sm:px-8 lg:px-12">
        {/* Top Section */}
        <div className="flex flex-col md:flex-row justify-between items-start md:items-start mb-10 gap-8">
          {/* Logo and Description */}
          <div className="flex-1 min-w-[180px] mb-8 md:mb-0 flex flex-col items-center md:items-start text-center md:text-left">
            <Link to="/">
              <img
                className="h-16 mb-3 mx-auto md:mx-0"
                src={logoImage}
                alt="Barma Sorig Logo"
              />
            </Link>
            <p className="text-gray-400 text-base leading-relaxed mb-2">
              Bringing ancient Traditional healing to the modern world.
              <br />
              Experience balance, harmony, and holistic well-being.
            </p>
          </div>

          {/* Navigation Links with Submenus */}
          <div className="flex-[2] w-full md:w-auto">
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 justify-items-center md:justify-items-start">
              {navigation
                .filter(
                  (item) =>
                    item.name !== "Home" &&
                    item.name !== "Gallery" &&
                    item.name !== "Services"
                )
                .map((mainMenu) => (
                  <div
                    key={mainMenu.name}
                    className="w-full text-center md:text-left"
                  >
                    <h4 className="text-base md:text-lg font-bold text-sky-400 mb-2 tracking-wide">
                      <Link
                        to={mainMenu.to}
                        className="hover:text-amber-400 transition"
                      >
                        {mainMenu.name}
                      </Link>
                    </h4>
                    {mainMenu.hasDropdown && (
                      <ul className="space-y-1 ml-0 md:ml-1">
                        {mainMenu.dropdownItems.map((submenu) =>
                          submenu.subServices ? (
                            <li key={submenu.name} className="mb-1">
                              <span className="font-semibold text-gray-300 text-sm">
                                {submenu.name}
                              </span>
                              <ul className="ml-2 mt-1 space-y-1">
                                {submenu.subServices.map((sub) => (
                                  <li key={sub.name}>
                                    <Link
                                      to={sub.to}
                                      className="text-gray-400 hover:text-amber-400 text-xs transition"
                                    >
                                      {sub.name}
                                    </Link>
                                  </li>
                                ))}
                              </ul>
                            </li>
                          ) : (
                            <li key={submenu.name}>
                              <Link
                                to={submenu.to}
                                className="text-gray-400 hover:text-amber-400 text-xs transition"
                              >
                                {submenu.name}
                              </Link>
                            </li>
                          )
                        )}
                      </ul>
                    )}
                  </div>
                ))}
            </div>
          </div>

          {/* Social Media & Contact */}
          <div className="flex-1 min-w-[160px] flex flex-col items-center md:items-start mt-8 md:mt-0 text-center md:text-left">
            <h3 className="text-base md:text-lg font-bold text-sky-400 mb-2">
              Connect
            </h3>
            <div className="flex flex-row md:flex-row gap-4 mb-3 justify-center md:justify-start">
              <a
                href="https://www.facebook.com/barmasorighealingcenter"
                className="text-gray-400 hover:text-sky-400 transition text-xl"
                aria-label="Facebook"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fab fa-facebook"></i>
              </a>
              <a
                href="/"
                className="text-gray-400 hover:text-pink-400 transition text-xl"
                aria-label="Instagram"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fab fa-instagram"></i>
              </a>
              <a
                href="/"
                className="text-gray-400 hover:text-red-500 transition text-xl"
                aria-label="YouTube"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fab fa-youtube"></i>
              </a>
            </div>
            <div className="mt-2">
              <span className="block text-gray-400 text-xs">
                Chubachu, Thimphu, Bhutan
              </span>
              <span className="block text-gray-400 text-xs mt-1">
                +975 17 248 226
              </span>
              <span className="block text-gray-400 text-xs mt-1">
                info@barma-sorig.com
              </span>
              <div className="mt-3">
                <h3 className="text-base font-bold text-sky-400 mb-1">
                  Opening Hours
                </h3>
                <p className="text-gray-400 text-xs">
                  Mon - Sun: 10:00 AM - 08:00 PM
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Divider */}
        <div className="border-t border-gray-700 my-4"></div>

        {/* Bottom Section */}
        <div className="flex flex-col md:flex-row justify-between items-center text-xs md:text-sm text-gray-500 gap-2 text-center md:text-left">
          <span>
            Designed &amp; Developed by{" "}
            <Link to="https://ngawang-tenzin.vercel.app" className="underline">
              CBMS
            </Link>
          </span>
          <span>
            <Link
              to="/privacy-policy"
              className="hover:text-sky-400 transition"
            >
              Privacy Policy
            </Link>
            &nbsp;|&nbsp;
            <Link
              to="/terms-of-service"
              className="hover:text-sky-400 transition"
            >
              Terms of Service
            </Link>
          </span>
        </div>
      </div>
      {/* Mobile Footer Overlay */}
      <style>{`
        @media (max-width: 640px) {
          footer .grid {
            justify-items: center !important;
          }
          footer .text-center,
          footer .text-center.md\\:text-left,
          footer .flex-1,
          footer .flex-col,
          footer .items-center,
          footer .justify-center {
            text-align: center !important;
            align-items: center !important;
            justify-content: center !important;
          }
          footer .mb-8.md\\:mb-0 {
            margin-bottom: 1.5rem !important;
          }
          footer .gap-4 {
            gap: 1rem !important;
          }
        }
      `}</style>
    </footer>
  );
}
